import type { FaireProductEntity } from "../../entity_types/product";

export const p_w6g9rax5sg: FaireProductEntity = {
  token: "p_w6g9rax5sg",
  type: "product",
  name: "Konosuba: God's Blessing on This Wonderful World!, Vol. 13",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/586312df99fade155ad3c94c8b9776ae04ce8d2d4c1e06acd6ec9a334617112e.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "Although Kazuma is reluctant to give up his riches and relaxation, Darkness’s mysterious departure drags him back into a life of…crime? Breaking and entering Darkness’s bedroom in the middle of the night might be outside the law, but for once, his intentions are pure. All he wants is to find out why she left, yet the truth is too perverse—even for Kazuma!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:35.259Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
